export default "__VITE_ASSET__131cbef4__"